import light from './light';
import dark from './dark';

const themes = {
  'light': light,
  'dark': dark
};

export default themes;
